import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.20_@babel+core@7.25.2_@opentelemetry+api@1.8.0_@playwright+test@1.46.0_react-dom@18_sxi2x3jccsj5uof26f3n4cy4oq/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["VConsoleComponent"] */ "/app/packages/platform/src/debug-utils/react/vConsoleComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/web/cheetah/src/features/branding/components/glassis-main-page/glassis-main-page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/web/cheetah/src/features/branding/components/glassis-teaser/glassis-teaser-page.tsx");
